import Component from "../abstracts/Component";
import { html } from "htm/preact";
import algoliasearch from "algoliasearch";
import { getAlgoliaResults } from "@algolia/autocomplete-preset-algolia";
import { autocomplete } from "@algolia/autocomplete-js";
import "@algolia/autocomplete-theme-classic";
import { getFocusableElements } from "../utils/TrapFocus";

export default class SearchLayerComponent extends Component {
  get SELECTORS() {
    return {
      closeBtn: "[data-search-close]",
      searchInput: "[data-search-input]",
      searchSuggestions: "[data-search-suggestions]",
      searchSuggestionsContainer: "[data-search-suggestions-container]",
      searchForm: "[data-search-form]",
      searchJsSubmit: ".js-search-submit",
      searchJsSubmitInput: "#search_field_box input"
    };
  }

  get CSS_CLASSNAMES() {
    return {
      open: "search-open"
    };
  }

  get CONST() {
    return {
      baseUrl: "https://query-suggestions.eu.algolia.com",
      baseUri: "/1/configs",
      indexName: "/"
    };
  }

  constructor(compEl) {
    super(compEl);
    this.closeBtn = this.$component.querySelector(this.SELECTORS.closeBtn);
    this.searchInput = this.$component.querySelector(
      this.SELECTORS.searchInput
    );
    this.searchSuggestions = this.$component.querySelector(
      this.SELECTORS.searchSuggestions
    );
    this.searchSuggestionsContainer = this.$component.querySelector(
      this.SELECTORS.searchSuggestionsContainer
    );
    this.searchForm = this.$component.querySelector(this.SELECTORS.searchForm);
    this.searchJsSubmit = this.$component.querySelector(
      this.SELECTORS.searchJsSubmit
    );
    this.searchJsSubmitInput = this.$component.querySelector(
      this.SELECTORS.searchJsSubmitInput
    );
    //
    this.searchFormUrl = this.searchForm.getAttribute("action");
    this.searchFormUrlJs = this.searchForm.getAttribute("data-js-search-url");
    this.input = this.$component.querySelector("input");
    this.scrollY = 0;
    this.searchIndex = this.$component.getAttribute("data-search-index");
    this.appID = this.$component.getAttribute("data-search-appID");
    this.apiKey = this.$component.getAttribute("data-search-apiKey");
    this.focusableEls = null;
  }

  openLayer() {
    this.$component.classList.add(this.CSS_CLASSNAMES.open);
    this.$component.setAttribute("aria-hidden", "false");
    if (window.matchMedia("(max-width: 991px)").matches) {
      let benefitBar = document.querySelector("[data-benefit-bar]");
      let barHeight = benefitBar ? benefitBar.offsetHeight : 0;
      this.scrollY = window.scrollY > barHeight ? window.scrollY : barHeight;
      document.body.style.position = "fixed";
      document.body.style.top = `-${barHeight}px`;
      document.body.style.width = "100%";
    }
    if (this.input != null) {
      this.input.focus();
    } else {
      let suggestionInput = document.querySelector(".aa-Input");
      if (suggestionInput != null) {
        suggestionInput.focus();
      }
    }
  }

  closeLayer() {
    this.$component.classList.remove(this.CSS_CLASSNAMES.open);
    this.$component.setAttribute("aria-hidden", "true");
    if (window.matchMedia("(max-width: 991px)").matches) {
      document.body.style.position = "";
      document.body.style.top = "";
      window.scrollTo(0, this.scrollY);
    }
    document.querySelector("[data-trigger-search]").focus();
  }

  listenClose() {
    if (!this.closeBtn) {
      return;
    }
    this.closeBtn.addEventListener("click", () => {
      this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.close);
    });
    this.closeBtn.addEventListener("keydown", e => {
      e.preventDefault();
      e.stopPropagation();
      (e.key === "Enter" || e.key === " ") &&
        this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.close);

      if (e.key === "Tab") {
        const firstFocusableEl = this.focusableEls[0];
        firstFocusableEl.focus();
      }
    });
  }

  getSuggestion(index, search = false) {
    let ctx = this;
    // X-Algolia-Application-Id: the application ID.
    // X-Algolia-API-Key: the admin API key for given application ID.
    const appId = this.appID;
    const apiKey = this.apiKey;
    const searchClient = algoliasearch(appId, apiKey);
    //
    autocomplete({
      debug: true,
      container: "#l-s__search",
      panelContainer: "#l-s__suggestions",
      placeholder: ctx.$component.dataset.searchPlaceholder,
      detachedMediaQuery: "none",
      getSources({ query }) {
        return [
          {
            sourceId: "querySuggestions",
            getItems() {
              return getAlgoliaResults({
                searchClient,
                queries: [
                  {
                    indexName: index,
                    query
                  }
                ]
              });
            },
            getItemUrl({ item }) {
              return item.url;
            },
            getItemInputValue({ item }) {
              return item.query;
            },
            templates: {
              header() {
                return "";
              },
              item({ item }) {
                // console.log(item);
                return html`<a href="${item.url}">${
                  item.summary
                } <span class="color"> ${item.color} </span></a>`;
              },
              footer() {
                return "";
              }
            }
          }
        ];
      }
    });
  }

  // bind keyup
  bindSearch() {
    let ctx = this;
    let timer;
    let index = ctx.$component.dataset.searchIndex;
    //ctx.$component.dataset.searchEnv + '_' + ctx.$component.dataset.searchBrand.toLowerCase() + '_' + ctx.$component.dataset.searchCountry + '_' + ctx.$component.dataset.searchLanguage;
    //
    ctx.getSuggestion(index);
  }

  jsSearchPage() {
    // get autocomplete value
    let autocompleteInput = this.$component.querySelector(
      this.SELECTORS.searchJsSubmitInput
    );
    // build url
    let url = this.searchFormUrlJs + "?text=" + autocompleteInput.value;
    // go to url
    window.location.href = url;
  }

  bindEvents() {
    let ctx = this;
    let trapFocusHandler = null;

    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.open, () => {
      this.openLayer();
      this.a11yAlgoliaFixes(); // fixes for Algolia unsed buttons
      this.focusableEls = getFocusableElements(this.$component);
      this.focusableEls &&
        this.focusableEls[0].addEventListener("keydown", e => {
          if (e.shiftKey && e.key === "Tab") {
            e.preventDefault();
            this.closeBtn.focus();
          }
        });
    });
    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.close, () => {
      this.closeLayer();
    });

    // if suggestions are enabled, i want to keep the standard search working
    if (this.searchJsSubmit != null) {
      this.searchJsSubmit.addEventListener("click", e => {
        e.preventDefault();
        // go
        this.jsSearchPage();
      });
      // enables Enter key to submit search
      this.searchForm.addEventListener("keypress", e => {
        if (e.keyCode === 13) {
          e.preventDefault();
          // go
          ctx.jsSearchPage();
        }
      });
    }

    this.$component.addEventListener("keydown", e => {
      if (e.keyCode === 27) {
        e.preventDefault();
        ctx.$emit(ctx.$customEvents.SEARCH_LAYER_EVENTS.close);
      }
    });

    this.listenClose();
  }
  /**
   * Fixes Algolia's unsed buttons
   * @returns {void}
   */
  a11yAlgoliaFixes() {
    const aaSubmit = document.querySelector(".aa-SubmitButton");
    const aaClear = document.querySelector(".aa-ClearButton");

    if (aaSubmit) {
      aaSubmit.setAttribute("tabindex", "-1");
      aaSubmit.disabled = true;
    }

    if (aaClear) {
      aaClear.setAttribute("tabindex", "-1");
      aaClear.disabled = true;
    }
  }

  render() {
    super.render();
    this.bindEvents();
    // if is enabled
    if (
      this.$component.attributes["data-search-suggestions"].nodeValue == "true"
    ) {
      this.bindSearch();
    }
  }
}
